import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { verticalTypesEnum } from '../enums/vertical-types.enum';
import { GamesService } from '../services/games.service';

/**
 * Returns recommended games
 */
export const useRecommendedGamesHook = ({ AsgFW, recentGamesLimit = 6 }) => {
    const { verticals } = useSelector((state) => state.app);
    const { gamesById } = useSelector((state) => state.casino);
    const [recommendedGames, setRecommendedGames] = useState([]);

    useEffect(() => {
        getCategories();
    }, []);

    const getCategories = () => {
        try {
            // Casino verticals, use only subcategories with gamesIds
            const casinoVerticals = verticals.filter(
                v => v.type === verticalTypesEnum.CASINO
                    && v.children !== null
                    && v.children.every(child => Boolean(child.gameIds))
            );

            const firstSubcategoryGames = casinoVerticals?.[0]?.children?.[0]?.gameIds ?? [];

            const filteredFirstSubcategoryGames = GamesService.filterGamesToRender(
                firstSubcategoryGames.slice(0, recentGamesLimit * 3), AsgFW
            );
            const recommendedGameIds = filteredFirstSubcategoryGames.slice(0, recentGamesLimit);

            let games = [];
            recommendedGameIds.forEach((value) => {
                let temp = gamesById[value];
                if (temp) {
                    games.push(temp);
                }
            });
            setRecommendedGames(games);

        } catch (e) {
            console.error('get categories game failed', e);
        }
    };

    return {
        recommendedGames,
    };
};
